import { render } from "./isfikirForm.vue?vue&type=template&id=7de2a683"
import script from "./isfikirForm.vue?vue&type=script&lang=js"
export * from "./isfikirForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__